module.exports = "/_next/static/images/742ba26c185a0ed64828759a1f43e42c-phone@1x.png";